/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geolayerusage2Inputs */

const en_geolayerusage2 = /** @type {(inputs: Geolayerusage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App opens`)
};

const de_geolayerusage2 = /** @type {(inputs: Geolayerusage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Öffnungen`)
};

/**
* | output |
* | --- |
* | "App opens" |
*
* @param {Geolayerusage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geolayerusage2 = /** @type {((inputs?: Geolayerusage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geolayerusage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geolayerusage2(inputs)
	return de_geolayerusage2(inputs)
});
export { geolayerusage2 as "geoLayerUsage" }